import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export class Modal {
  constructor({ template, additionalClasses = [], created, heading = '' }) {
    this.modalEl = null
    this.template = template
    this.additionalClasses = additionalClasses
    this.heading = heading

    this.unicId = `instance-${this.template.id}`
    this.createModal()
    this.scrollingElement = this.modalEl.querySelector('.modal-content__inner')
    if (typeof created === 'function') {
      created(this)
    }
  }
  createModal() {
    this.modalEl = document.createElement('div')
    this.modalEl.id = this.unicId
    this.modalEl.classList.add('modal', ...this.additionalClasses)
    this.modalEl.innerHTML = /*html*/ `
      <div class="modal-content">
        <button class="modal-close" data-close-modal>
          <span class="icon-close"></span>
        </button>
        <div class="modal-heading">
          <button class="modal-heading__close" data-close-modal>
            <span class="icon-long-arrow-left"></span>
          </button>
          <div class="modal-heading__title">${this.heading || 'Modal'}</div>
        </div>
        <div class="modal-content__inner"></div>
      </div>
    `
    this.modalEl
      .querySelector('.modal-content__inner')
      .append(this.template.content)
  }
  normalizeImages() {
    this.modalEl.querySelectorAll('img[data-src]').forEach((image) => {
      image.src = image.dataset.src
      delete image.dataset.src
    })
  }
  open() {
    this.eventsController(true)
    document.body.append(this.modalEl)
    this.normalizeImages()
    disableBodyScroll(this.scrollingElement, {
      allowTouchMove: (el) => {
        while (el && el !== this.scrollingElement.parentElement) {
          if (el.dataset.modalScrolling) {
            return true
          }
          el = el.parentElement
        }
      }
    })
  }
  close() {
    this.eventsController(false)
    this.modalEl.remove()
    enableBodyScroll(this.scrollingElement)
  }

  eventsController(isAppend) {
    if (isAppend) {
      this.modalEl.addEventListener('click', this.closeHandler.bind(this))
    } else {
      this.modalEl.removeEventListener('click', this.closeHandler)
    }
  }

  closeHandler(event) {
    if (
      event.target.classList.contains('modal') ||
      event.target.closest('[data-close-modal]')
    ) {
      this.close()
    }
  }
}
